import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: any;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  data: null,
};

const getTimeConfirmPeriodSlice = createSlice({
  name: "getTimeConfirmPeriod",
  initialState,
  reducers: {
    getTimeConfirmPeriodStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getTimeConfirmPeriodSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getTimeConfirmPeriodFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetGetTimeConfirmPeriod: (state) => initialState,
  },
});

export const {
  getTimeConfirmPeriodStart,
  getTimeConfirmPeriodSuccess,
  getTimeConfirmPeriodFailed,
  resetGetTimeConfirmPeriod,
} = getTimeConfirmPeriodSlice.actions;

export default getTimeConfirmPeriodSlice.reducer;
